import { useRootLoaderData } from 'components/Root.loader'
import { CONFIDENCE_COLOR } from 'config'

export default function useConfidenceColor(confidence) {
  const systemSettings = useRootLoaderData().systemSettings.systemSettings

  if (!systemSettings.confidence || !confidence) {
    return undefined
  }

  const highMin = systemSettings.highMin * 0.01
  const midMin = systemSettings.midMin * 0.01

  if (confidence < midMin) {
    // 低精度チェック
    return CONFIDENCE_COLOR.low
  } else if (midMin <= confidence && confidence < highMin) {
    // 中精度チェック
    return CONFIDENCE_COLOR.mid
  }
  return undefined
}
